"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "callabiana": {
    "a0b4e432": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "skipSearch": false
    }],
    "corte": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65f0344e": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "skipSearch": false
    }],
    "nelva": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "113240df": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "skipSearch": false
    }],
    "pettani": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33b1fc21": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "skipSearch": false
    }],
    "pianezze": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85f7d229": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "skipSearch": false
    }],
    "trabbia": [{
      "hkey": "eeb1d99c",
      "slug": "callabiana",
      "name": "Callabiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;